const state = {
  id: null,
  brand_id: null,
  cache_key: null,
  title: '',
}

export const requiredFields = [
  { key: 'brand_id' },
  { key: 'title' },
]

export default state
